import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {GamesRouting} from '@modules/home/tabs/games/games.routing';
import {SharedModule} from '@shared/shared.module';
import {GamesService} from '@app/modules/home/tabs/games/services/games.service';
import {LibTableModule} from '@lib-modules/table/lib-table.module';
import {FilterModule} from '@shared/components/filter/filter.module';
import { GamesComponent } from './pages/games.component';
import { AllGamesComponent } from './pages/all-games/all-games.component';
import { LibGamesModule } from '@components/games/lib-games.module';
import { MyGamesComponent } from './pages/my-games/my-games.component';
import { GamesPlaceholderComponent } from './components/games-placeholder/games-placeholder.component';

@NgModule({
  imports: [
    CommonModule,
    GamesRouting,
    SharedModule,
    LibTableModule,
    FilterModule,
    LibGamesModule
  ],
  declarations: [
    GamesComponent,
    AllGamesComponent,
    MyGamesComponent,
    GamesPlaceholderComponent
  ],
  providers: [
    GamesService
  ]
})
export class GamesModule { }
